export default {"src":"/_next/static/media/unichain.02b81e3e.svg","height":115,"width":116,"blurWidth":0,"blurHeight":0};